import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import TourManagementOptionsSidebar from "../components/tour/TourManagementSidebarOptionsSidebar";
import CustomRadio from "../components/common/CustomRadio";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setOptionsData, setPackageData } from "../reducer/tourReducer";
import { useOptions } from "../hooks/useOptions";
import { resetOptionEdit } from "../reducer/tourEditReducer";

function TourManagementPackageAvailabilityPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { packageData, optionsData } = useSelector(
    (state: RootState) => state.tour
  );
  const {
    tourEdit,
    optionId,
    id: editPackageId,
  } = useSelector((state: RootState) => state.edit);
  const { createPreOptions } = useOptions();
  const progressref = useRef(14);

  useEffect(() => {
    if (location.state && location.state.optionData) {
      dispatch(setOptionsData(location.state.optionData));
    }
  }, [location.state, dispatch]);

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState("");

  const [editedAvailability, setEditedAvailability] = useState<string>(
    optionsData?.availability || ""
  );

  const [editedPriceByGroup, setEditedPriceByGroup] = useState<boolean>(
    optionsData?.pricingOption === "vehicle" || false
  );

  useOnLoadPage({ tabActive: "create" });

  const onContinue = async () => {
    console.log(packageData);

    const updatedPackageData = {
      ...optionsData,
      id: optionsData._id,
      progress: Number(progressref.current),
      availability: optionsData?.availability,
      priceByGroup: optionsData?.priceByGroup,
    };

    const updatedPackageData2 = {
      ...optionsData,
      ...updatedPackageData,
    };

    dispatch(setOptionsData(updatedPackageData));

    try {
      if (tourEdit) {
        dispatch(resetOptionEdit());
        dispatch(setOptionsData(updatedPackageData2));
        const pkgId = packageData._id;
        navigate(`/manage/product/${pkgId}/${optionId}`, {
          state: {
            fromEdit: true,
            option: updatedPackageData2,
            packageId: pkgId,
          },
        });
        return;
      } else {
        await createPreOptions(updatedPackageData);
      }
      navigate(Paths.tourManagementPackageOptionsAvailabilitySchedule);
    } catch (error) {
      console.error("Error saving package:", error);
      setError("Failed to save the package. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddSchedule = () => {
    navigate(Paths.tourManagementPackageOptionsAvailabilitySchedule);
  };

  useEffect(() => {
    if (typeof optionsData?.pricingOption === "undefined") {
      dispatch(setOptionsData({ ...optionsData, priceByGroup: false }));
    }
    if (typeof optionsData?.availability === "undefined") {
      dispatch(
        setOptionsData({ ...optionsData, availability: "fixed_time_slots" })
      );
    }
  }, []);

  console.log("package", packageData);
  return (
    <div className={Classname.container}>
      <Navbar />
      <div className={Classname.content}>
        <TourManagementOptionsSidebar selected={4} />
        <div className={Classname.detail}>
          <div className={Classname.title}>Availability & Pricing</div>
          <div className={Classname.description}>
            This will apply to all the schedules added to this option.
          </div>
          <div className={Classname.title2}>
            Does your activity have fixed time slots or operating hours?
          </div>
          <CustomRadio
            label="Fixed time slots"
            description="Example: walking tour starting at 9:00 AM"
            value={"fixed_time_slots"}
            selected={editedAvailability}
            onSelect={() => {
              setEditedAvailability("fixed_time_slots");
              dispatch(
                setOptionsData({
                  ...optionsData,
                  availability: "fixed_time_slots",
                })
              );
            }}
          />
          <CustomRadio
            label="Operating hours"
            description="Example: museum open from Mon to Sat, between 9:00 AM and 7:00 PM"
            value={"operating_hours"}
            selected={editedAvailability}
            onSelect={() => {
              setEditedAvailability("operating_hours");
              dispatch(
                setOptionsData({
                  ...optionsData,
                  availability: "operating_hours",
                })
              );
            }}
          />

          <div className={Classname.title2}>How do you set your prices?</div>
          <CustomRadio
            label="Price per person"
            description="Set different prices for adults, youth, child, etc."
            value={false}
            selected={editedPriceByGroup}
            onSelect={() => {
              setEditedPriceByGroup(false);
              dispatch(
                setOptionsData({
                  ...optionsData,
                  priceByGroup: false,
                })
              );
            }}
          />
          <CustomRadio
            label="Price per group/vehicle"
            description="Price per group/vehicle"
            value={true}
            selected={editedPriceByGroup}
            onSelect={() => {
              setEditedPriceByGroup(true);
              dispatch(
                setOptionsData({
                  ...optionsData,
                  priceByGroup: true,
                  pricingOption: "vehicle",
                })
              );
            }}
          />
          <button
            className={Classname.addressButton}
            onClick={handleAddSchedule}
          >
            Add new schedule
          </button>
          {tourEdit && (
            <div className={Classname.buttonsContainer}>
              <button
                className={Classname.continueButton}
                onClick={onContinue}
                disabled={loading}
              >
                {loading ? "Please Wait..." : "Save and Continue"}
              </button>
            </div>
          )}
        </div>
      </div>{" "}
    </div>
  );
}

export default TourManagementPackageAvailabilityPage;

const Classname = {
  container:
    "flex w-full min-h-screen relative bg-white flex-col items-center font-main",
  content:
    "flex flex-col lg:flex-row w-full max-w-7xl flex-1 pt-10 lg:pt-0 max-lg:px-4",
  detail: "flex flex-col py-10 lg:px-6 w-full",
  title: "font-bold text-lg mt-6 mb-2",
  title2: "font-bold lg:text-lg mt-6 mb-2",
  input: "flex w-full h-14 border border-gray-400 rounded-md px-4 mt-2",
  textarea:
    "flex w-full h-44 py-4 border border-gray-400 rounded-md px-4 mt-2 mb-6 ",
  description: "flex text-base mb-4 mt-2",
  buttonsContainer: "flex flex-1 justify-end gap-3 mt-10",
  addressButton:
    "font-bold w-fit flex items-center gap-2 cursor-pointer text-primary1 py-3 px-3 border-primary1 border rounded-lg mt-6",
  saveButton:
    "h-12 px-6 flex items-center justify-center font-bold text-gray-700 border border-gray-500 rounded-md",
  continueButton:
    "h-12 px-6 flex items-center justify-center text-white font-bold bg-primary1 rounded-md",
};
